import { getJSON, postJSON } from "../../shared_component/utils/fetch"
import { getApiBaseUrl } from "../../shared_component/utils/urlUtils"
import { setAndUpdateFuelcardModal } from "./user"

const FUELCARD_BASE_URL = `${getApiBaseUrl()}/api/v6/fuel_card/`
const AFFILIATION_MODAL = `${getApiBaseUrl()}/api/v6/affiliations/`
const GET_FUELCARD = "cards"
const USER_PROMOTION = "user_promotions"

export function getFuelcards(payload) {
  return async function (dispatch, getState) {
    let user = getState().user || {}
    let { authentication_token } = user
    if (authentication_token) {
      let request = {
        headers: { Authorization: authentication_token }
      }
      let url = `${FUELCARD_BASE_URL}${GET_FUELCARD}`

      const response = await getJSON(url, {}, request.headers)

      if (response.result) {
        return response
      } else {
        payload.callback && payload.callback("failure", { message: response.error })
      }
      return response
    }
  }
}

export function closeFuelcardMarketingModal(payload) {
  return async function (dispatch, getState) {
    const { user } = getState()

    dispatch(setAndUpdateFuelcardModal({ flag: false }))

    const response = await postJSON(
      `${AFFILIATION_MODAL}${user.affiliation_id}/${USER_PROMOTION}`,
      {
        show_membership_benefits: false
      },
      {
        Authorization: user.authentication_token
      }
    )

    if (response.result) {
      return response
    } else {
      payload.callback && payload.callback("failure", { message: response.error })
    }
    return response
  }
}

export function getFuelcardModalValue(payload) {
  return async function (dispatch, getState) {
    let user = getState().user || {}

    const response = await getJSON(
      `${AFFILIATION_MODAL}${user.affiliation_id}/${USER_PROMOTION}`,
      {},
      {
        Authorization: user.authentication_token
      }
    )

    if (response.result) {
      dispatch(setAndUpdateFuelcardModal({ flag: response?.result?.show_membership_benefits }))
      return response
    } else {
      payload.callback && payload.callback("failure", { message: response.error })
    }
    return response
  }
}
